// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__23rJN","buttonSearch":"SearchBar_buttonSearch__2ocuW"};